'use strict';

bbw.directive.bbwScrollBottom = ['bbw.OffsetCalcSvc', '$rootScope', function(offsetCalcSvc, $rootScope) {

    var getScrollBottom = function() {
        return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
            + (window.innerHeight || document.documentElement.clientHeight);
    };

    return {
        scope: {
            'handler': '=bbwScrollBottom',
            'distance': '=distance'
        },
        link: function(scope, element) {
            var handler = scope.handler;
            if (!(handler instanceof bbw.service.ScrollBottomHandler)) {
                throw new Error("bbw-scroll-bottom handler is expected to be an instance of ScrollBottomHandler");
            }

            var canLoad = function() {
                return handler.hasMore() && !handler.isLoading() && handler.canMore();
            };

            var apply = function() {
                $rootScope.$safeApply();
            };

            var calc = function() {
                if (!canLoad()) {
                    return;
                }
                var distance = scope.distance || 1;
                var top = offsetCalcSvc.top(element) - (window.innerHeight || document.documentElement.clientHeight) * distance;
                if (top < 1) {
                    top = 1;
                }
                var shouldLoadMore = (getScrollBottom(distance) >= top);
                if (shouldLoadMore) {
                    var result = handler.loadMore();
                    if (angular.isFunction(result.finally)) {
                        result.finally(apply);
                    } else {
                        apply();
                    }
                }
            };

            var isPostDigestRegistered = false;
            var destroyed = false;

            scope.$watch(function() {
                if (isPostDigestRegistered || destroyed) {
                    return;
                }
                isPostDigestRegistered = true;
                scope.$$postDigest(function() {
                    isPostDigestRegistered = false;
                    calc();
                });
            });

            window.addEventListener('resize', calc);
            window.addEventListener('scroll', calc);

            var destroy = function() {
                if (!destroyed) {
                    destroyed = true;
                    window.removeEventListener('resize', calc);
                    window.removeEventListener('scroll', calc);
                }
            };
            scope.$on('$destroy', destroy);
            element.on('$destroy', destroy);
        }
    }

}];
